import product1 from '../../images/2.jpg'
import product2 from '../../images/5.jpg'
import product3 from '../../images/10.jpg'
import sweet1 from '../../images/13.jpg'
import sweet2 from '../../images/14.jpg'
import sweet3 from '../../images/18.jpg'

export const productData = [
    {
        img: product1,
        alt: 'Pizza',
        name: 'Supreme Pizza',
        desc: 'Marinara sauce, basil, Italian sausage, roma tomatoes, olives, and pesto',
        price: '$19.99',
        button: 'Add to cart'
    },
    {
        img: product2,
        alt: 'Pizza',
        name: 'Supreme Pizza',
        desc: 'Marinara sauce, basil, Italian sausage, roma tomatoes, olives, and pesto',
        price: '$19.99',
        button: 'Add to cart'
    },
    {
        img: product3,
        alt: 'Pizza',
        name: 'Supreme Pizza',
        desc: 'Marinara sauce, basil, Italian sausage, roma tomatoes, olives, and pesto',
        price: '$19.99',
        button: 'Add to cart'
    }
]


export const productDataTwo = [
    {
        img: sweet1,
        alt: 'Pizza',
        name: 'Supreme Pizza',
        desc: 'Marinara sauce, basil, Italian sausage, roma tomatoes, olives, and pesto',
        price: '$19.99',
        button: 'Add to cart'
    },
    {
        img: sweet2,
        alt: 'Pizza',
        name: 'Supreme Pizza',
        desc: 'Marinara sauce, basil, Italian sausage, roma tomatoes, olives, and pesto',
        price: '$19.99',
        button: 'Add to cart'
    },
    {
        img: sweet3,
        alt: 'Pizza',
        name: 'Supreme Pizza',
        desc: 'Marinara sauce, basil, Italian sausage, roma tomatoes, olives, and pesto',
        price: '$19.99',
        button: 'Add to cart'
    }
]